

import UMUM from "../../library/umum.js";

export default {
    data() {
        return {
            UMUM: UMUM,
            tipe: 0, // dari profile.stokdarah_konut
            user: null,

            // form tambah permintaan (admin ruangan)
            form: {
                rumah_sakit_id: 1,
                ruangan_id: null,
                nama_dokter: '',
                tanggal_permintaan: '',
                tanggal_diperlukan: '',
                nama_pasien: '',
                nomor_rm: '',
                tanggal_lahir: '',
                alamat: '',
                nama_wali: '',
                jenis_kelamin: '',
                jumlah_kehamilan: null,
                pernah_abortus: '',
                pernah_hdn: '',

                transfusi_sebelumnya: 'Tidak',
                transfusi_kapan: '',
                reaksi_transfusi: 'Tidak',
                gejala_transfusi: '',

                coomb_test: 'Tidak',
                coomb_tempat: '',
                coomb_kapan: '',
                coomb_hasil: '',

                golongan_darah: '',
                rhesus: '',
                komponen_id: null,
                jumlah_kantong: 1,
                jumlah_cc: '',
                diagnosis_klinis: '',
                alasan_transfusi: '',
                kadar_hb: null,
                status: 1, // default 1 = diajukan
                status_keterangan: 'Menunggu Diperiksa oleh Admin UPD'
            },

            // modal edit
            mdl_edit: false,
            mdl_delete: false,
            btn_edit: false,


            // form edit
            form_edit: {
                id: null,
                rumah_sakit_id: 1,
                ruangan_id: null,
                nama_dokter: '',
                tanggal_permintaan: '',
                tanggal_diperlukan: '',
                nama_pasien: '',
                nomor_rm: '',
                tanggal_lahir: '',
                alamat: '',
                nama_wali: '',
                jenis_kelamin: '',
                jumlah_kehamilan: null,
                pernah_abortus: '',
                pernah_hdn: '',
                golongan_darah: '',
                rhesus: '',
                komponen_id: null,
                jumlah_kantong: 1,
                jumlah_cc: '',
                diagnosis_klinis: '',
                alasan_transfusi: '',
                kadar_hb: null,
                status: 1,
                status_keterangan: '',
                transfusi_sebelumnya: 'Tidak',
                transfusi_kapan: '',
                reaksi_transfusi: 'Tidak',
                gejala_transfusi: '',
                coomb_test: 'Tidak',
                coomb_tempat: '',
                coomb_kapan: '',
                coomb_hasil: ''
            },

            // tambah di data()
            periksa_target: null, // dipakai di template untuk ringkasan sebelum periksa
            // form1 dipakai oleh template modal tahap 1 (sesuaikan struktur)
            form1: {
                id: null,
                petugas_pemeriksa: '',
                tanggal_pemeriksaan: null,
                komponen_id: null,
                // golongan_darah_hasil: '',
                golongan_darah: '',
                rhesus: '',
                exp: '',
                // rhesus_hasil: '',
                kadar_hb: null,
                catatan_tambahan: '',
                crossmatch_1: '',
                crossmatch_2: '',
                crossmatch_3: '',
                jumlah_darah_diberikan: null,
                jumlah_darah_diberikan_cc: null,
                nomor_kantong: ''
            },
            loading1: false, // jika dipakai sebagai v-loading pada tombol Simpan Tahap1




            list_data: [],
            list_komponen: [],
            list_ruangan: [],

            mdl_keterangan: false,
            selectedItem: {},

            page_first: 1,
            page_last: 0,
            page_limit: 10,
            jml_data: 0,
            total_data: 0,
            cari_value: '',

            mdl_add: false,
            btn_add: false,

            mdl_lihat: false,
            lihat_target: null,

            filter: {
                komponen_id: '',
                golongan_darah: '',
                status: ''
            },

            statusOptions: [
                { label: 'Semua', value: null },
                { label: 'Diajukan', value: 1 },
                { label: 'Diperiksa', value: 2 },
                { label: 'Siap Diambil', value: 3 },
                { label: 'Selesai', value: 4 },
                { label: 'Ditolak', value: 5 },
                { label: 'Telah Diambil', value: 6 }
            ],

            mdl_periksa: false,
            mdl_reject: false,
            btn_periksa: false,
            btn_reject: false,

            reject_reason: '',
            /* ===== Stage 2 (Pengambilan) state ===== */
            mdl_stage2: false,
            stage2_target: null,
            form2: {
                petugas_pengeluar: '',
                penerima_darah: '',

                catatan_pengambilan: ''
            },
            loading2: false,
            mdl_taken: false,
            mdl_taken_ruangan: false,
            taken_target: null,
            loadingTaken: false,

            mdl_revert: false,
            revert_target: null,
            loadingRevert: false


        }
    },

    methods: {

        bukaPdf() {
            if (!this.lihat_target?.id || !this.lihat_target?.pdf_key) {
                this.$q.notify({
                type: 'negative',
                message: 'PDF belum tersedia'
                })
                return
            }
           

            window.open(
                `https://server-pindara.bludrs-konut.id/api/v1/permintaan_darah/pdf/${this.lihat_target.id}?key=${this.lihat_target.pdf_key}`,
                '_blank'
            )
            // window.open(
            //     `http://localhost:5088/api/v1/permintaan_darah/pdf/${this.lihat_target.id}?key=${this.lihat_target.pdf_key}`,
            //     '_blank'
            // )
        },

        openRevertModal(row) {
            this.revert_target = row;
            this.mdl_revert = true;
        },

        async confirmRevert() {
            if (!this.revert_target || !this.revert_target.id) {
                this.$q.notify({ type: 'negative', message: 'Data tidak valid' });
                this.mdl_revert = false;
                this.revert_target = null;
                return;
            }

            const row = this.revert_target;
            const payload = {
                id: row.id,
                previous_status: row.status,
                status: 2,
                status_keterangan: 'Dikembalikan ke Diperiksa oleh Admin UPD'
            };

            try {
                this.loadingRevert = true;

                const res = await this.updateStatusRequest(payload);

                if (res && res.success) {
                    this.$q.notify({
                        type: 'positive',
                        message: res.message || 'Berhasil mengembalikan ke Diperiksa'
                    });

                    row.status = 2;

                    if (this.lihat_target && this.lihat_target.id === row.id) {
                        this.lihat_target.status = 2;
                        this.lihat_target.status_keterangan = payload.status_keterangan;
                    }

                    this.mdl_revert = false;
                    this.revert_target = null;

                    await this.openPeriksaFor(row);
                } else {
                    this.$q.notify({
                        type: 'negative',
                        message: res?.message || 'Gagal mengubah status'
                    });

                    this.mdl_revert = false;
                    this.revert_target = null;
                }

            } catch (err) {
                console.error('confirmRevert error', err);
                this.$q.notify({
                    type: 'negative',
                    message: 'Terjadi kesalahan saat mengubah status'
                });
                this.mdl_revert = false;
                this.revert_target = null;
            } finally {
                this.loadingRevert = false;
            }
        },
        async handleRevertToPeriksa(row) {
            if (!row || !row.id) {
                this.$q.notify({ type: 'negative', message: 'Data tidak valid' });
                return;
            }

            // optional: konfirmasi singkat
            const ok = await this.$q.dialog({
                title: 'Konfirmasi',
                message: 'Kembalikan permintaan ini ke status Diperiksa (2) dan buka form Pemeriksaan UPD?',
                cancel: true,
                persistent: true
            }).onOk(() => true).onCancel(() => false).onDismiss(() => false);

            if (!ok) return;

            // payload untuk backend (sesuaikan field sesuai API Anda)
            const payload = {
                id: row.id,
                previous_status: row.status,
                status: 2,
                status_keterangan: 'Dikembalikan ke Diperiksa oleh Admin UPD'
            };

            try {
                this.$q.loading.show();
                const res = await this.updateStatusRequest(payload);
                if (res && res.success) {
                    this.$q.notify({ type: 'positive', message: res.message || 'Berhasil mengembalikan ke Diperiksa' });

                    // update lokal agar UI langsung reflektif
                    row.status = 2;
                    if (this.lihat_target && this.lihat_target.id === row.id) {
                        this.lihat_target.status = 2;
                        this.lihat_target.status_keterangan = payload.status_keterangan;
                    }

                    // buka modal pemeriksaan (Tahap 1) — ini sudah ada di file: openPeriksaFor
                    await this.openPeriksaFor(row);
                } else {
                    this.$q.notify({ type: 'negative', message: res?.message || 'Gagal mengubah status' });
                }
            } catch (err) {
                console.error('handleRevertToPeriksa error', err);
                this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat mengubah status' });
            } finally {
                this.$q.loading.hide();
            }
        },


        statusColor(st) {
            const s = Number(st);
            if (s === 1) return 'orange';    // Diajukan
            if (s === 2) return 'info';      // Diperiksa
            if (s === 3) return 'secondary'; // Siap Diambil (gunakan warna berbeda)
            if (s === 4) return 'positive';  // Selesai (diambil)
            if (s === 5) return 'negative';  // Ditolak
            if (s === 6) return 'accent';  // Ditolak
            return 'grey';
        },
        getView() {
            const queryObj = {
                page: this.page_first,
                limit: this.page_limit,
                cari_value: this.cari_value || '',
                komponen_id: this.filter.komponen_id || '',
                golongan_darah: this.filter.golongan_darah || ''
            };

            // hanya kirim status jika ada isinya
            if (this.filter.status !== null && this.filter.status !== '') {
                queryObj.status = this.filter.status;
            }

            const query = new URLSearchParams(queryObj).toString();


            // sesuaikan key URL di store: gunakan PERMINTAAN
            const URL = this.$store.state.url.PERMINTAAN || (this.$store.state.url.BASE || '') + "permintaan_darah/";

            fetch(URL + "view?" + query, {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success) {
                        this.list_data = res_data.data || []
                        this.total_data = res_data.total_data || 0
                        this.page_last = res_data.total_pages || 1
                        this.jml_data = this.list_data.length
                        if (this.page_first > this.page_last) this.page_first = this.page_last || 1
                    } else {
                        this.$q.notify({ type: 'negative', message: res_data.message || 'Gagal memuat data permintaan darah' })
                    }
                })
                .catch(err => {
                    console.error('Error fetching permintaan:', err)
                    this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat memuat data permintaan darah' })
                })
        },

        getKomponen() {
            const URL = this.$store.state.url.KOMPONEN || (this.$store.state.url.BASE || '') + "komponen_darah/";
            fetch(URL + "view", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({})
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_komponen = res_data.data || []
                })
                .catch(err => console.error("Error getKomponen:", err))
        },

        // getRuangan() {
        //     // ganti key URL sesuai store kamu; saya asumsikan ada this.$store.state.url.TENAGA_MEDIS
        //     const URL = this.$store.state.url.REGIS_MEDIS || (this.$store.state.url.BASE || '') + "getview/";
        //     fetch(URL + "getview", {
        //         method: "POST",
        //         headers: {
        //             "content-type": "application/json",
        //             authorization: "kikensbatara " + localStorage.token
        //         },
        //         body: JSON.stringify({})
        //     })
        //         .then(res => res.json())
        //         .then(res_data => {
        //             // server diharapkan mengembalikan array objek tenaga_medis dengan properti id dan nama_ruangan
        //             this.list_ruangan = res_data.data || []
        //         })
        //         .catch(err => console.error("Error getRuangan:", err))
        // },


        addData() {
            this.btn_add = true
            if (this.form.jenis_kelamin === 'P') {
                if (this.form.jumlah_kehamilan === null || this.form.jumlah_kehamilan === '') {
                    this.$q.notify({ type: 'negative', message: 'Jumlah kehamilan harus diisi untuk pasien wanita' });
                    return;
                }
            }

            if (this.form.transfusi_sebelumnya === 'Ya') {
                if (!this.form.transfusi_kapan || this.form.transfusi_kapan.trim() === '') {
                    this.$q.notify({ type: 'negative', message: 'Mohon isi tanggal/keterangan transfusi sebelumnya.' });
                    this.btn_add = false;
                    return;
                }
            }

            if (this.form.reaksi_transfusi === 'Ya') {
                if (!this.form.gejala_transfusi || this.form.gejala_transfusi.trim() === '') {
                    this.$q.notify({ type: 'negative', message: 'Mohon jelaskan gejala reaksi transfusi.' });
                    this.btn_add = false;
                    return;
                }
            }

            if (this.form.coomb_test === 'Ya') {
                if (!this.form.coomb_tempat || this.form.coomb_tempat.trim() === '' ||
                    !this.form.coomb_kapan || this.form.coomb_kapan.trim() === '' ||
                    !this.form.coomb_hasil || this.form.coomb_hasil.trim() === '') {
                    this.$q.notify({ type: 'negative', message: 'Mohon lengkapi data pemeriksaan serologi (Coomb\'s test): tempat, kapan, dan hasil.' });
                    this.btn_add = false;
                    return;
                }
            }

            const URL = this.$store.state.url.PERMINTAAN || (this.$store.state.url.BASE || '') + "permintaan_darah/";

            fetch(URL + "addData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.form)
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success) {
                        this.$q.notify({ type: "positive", message: res_data.message || "Permintaan berhasil ditambahkan" })
                        this.mdl_add = false
                        this.resetForm()
                        this.getView()
                    } else {
                        this.$q.notify({ type: "negative", message: res_data.message || "Gagal menambah permintaan" })
                    }
                })
                .catch(err => {
                    console.error("Error addData:", err)
                    this.$q.notify({ type: "negative", message: "Gagal menambah permintaan darah" })
                })
                .finally(() => {
                    this.btn_add = false
                })
        },

        resetForm() {
            let ruanganId = null
            let rumahSakitId = 1

            try {
                const p = JSON.parse(localStorage.profile || '{}')
                if (p?.profile?.ruangan_id) {
                    ruanganId = Number(p.profile.ruangan_id)
                }
                if (p?.profile?.rumah_sakit_id) {
                    rumahSakitId = Number(p.profile.rumah_sakit_id)
                }
            } catch (e) { }
            this.form = {
                rumah_sakit_id: 1,
                ruangan_id: ruanganId,
                nama_dokter: '',
                tanggal_permintaan: '',
                tanggal_diperlukan: '',
                nama_pasien: '',
                nomor_rm: '',
                tanggal_lahir: '',
                alamat: '',
                nama_wali: '',
                jenis_kelamin: '',
                jumlah_kehamilan: null,
                pernah_abortus: '',
                pernah_hdn: '',
                golongan_darah: '',
                rhesus: '',
                komponen_id: null,
                jumlah_kantong: 1,
                jumlah_cc: '',
                diagnosis_klinis: '',
                alasan_transfusi: '',
                kadar_hb: null,
                status: 1,
                status_keterangan: 'Menunggu Diperiksa oleh Admin UPD',
                transfusi_sebelumnya: 'Tidak',
                transfusi_kapan: '',
                reaksi_transfusi: 'Tidak',
                gejala_transfusi: '',
                coomb_test: 'Tidak',
                coomb_tempat: '',
                coomb_kapan: '',
                coomb_hasil: ''
            }
        },

        openEdit(row) {
            if (!row || !row.id) {
                this.$q.notify({ type: 'negative', message: 'Data tidak valid untuk edit' });
                return;
            }

            // jika sudah disetujui, jangan buka modal (double-check frontend)
            if (Number(row.status) === 3) {
                this.$q.notify({ type: 'warning', message: 'Tidak dapat mengedit: permintaan sudah Disetujui' });
                return;
            }

            // copy data ke form_edit (hindari binding langsung)
            this.form_edit = Object.assign({}, {
                id: row.id,
                rumah_sakit_id: row.rumah_sakit_id || 1,
                ruangan_id: row.ruangan_id || null,
                nama_dokter: row.nama_dokter || '',
                tanggal_permintaan: row.tanggal_permintaan || '',
                tanggal_diperlukan: row.tanggal_diperlukan || '',
                nama_pasien: row.nama_pasien || '',
                nomor_rm: row.nomor_rm || '',
                tanggal_lahir: row.tanggal_lahir || '',
                alamat: row.alamat || '',
                nama_wali: row.nama_wali || '',
                jenis_kelamin: row.jenis_kelamin || '',
                jumlah_kehamilan: row.jumlah_kehamilan || null,
                pernah_abortus: row.pernah_abortus || '',
                pernah_hdn: row.pernah_hdn || '',
                golongan_darah: row.golongan_darah || '',
                rhesus: row.rhesus || '',
                komponen_id: row.komponen_id || null,
                jumlah_kantong: row.jumlah_kantong || 1,
                jumlah_cc: row.jumlah_cc || 1,
                diagnosis_klinis: row.diagnosis_klinis || '',
                alasan_transfusi: row.alasan_transfusi || '',
                kadar_hb: row.kadar_hb || null,
                status: row.status || 1,
                status_keterangan: row.status_keterangan || '',
                transfusi_sebelumnya: row.transfusi_sebelumnya || 'Tidak',
                transfusi_kapan: row.transfusi_kapan || '',
                reaksi_transfusi: row.reaksi_transfusi || 'Tidak',
                gejala_transfusi: row.gejala_transfusi || '',
                coomb_test: row.coomb_test || 'Tidak',
                coomb_tempat: row.coomb_tempat || '',
                coomb_kapan: row.coomb_kapan || '',
                coomb_hasil: row.coomb_hasil || ''
            });

            this.mdl_edit = true;
        },

        async submitEdit() {
            // simple validation
            if (!this.form_edit || !this.form_edit.id) {
                this.$q.notify({ type: 'negative', message: 'Data edit tidak lengkap' });
                return;
            }

            // do not allow save if status is 3 on client side
            if (Number(this.form_edit.status) === 3) {
                this.$q.notify({ type: 'warning', message: 'Tidak dapat menyimpan: status sudah Disetujui' });
                return;
            }
            // validation for additional fields
            if (this.form_edit.jenis_kelamin === 'P') {
                if (this.form_edit.jumlah_kehamilan === null || this.form_edit.jumlah_kehamilan === '') {
                    this.$q.notify({ type: 'negative', message: 'Jumlah kehamilan harus diisi untuk pasien wanita' });
                    return;
                }
            }

            if (this.form_edit.transfusi_sebelumnya === 'Ya') {
                if (!this.form_edit.transfusi_kapan || this.form_edit.transfusi_kapan.trim() === '') {
                    this.$q.notify({ type: 'negative', message: 'Mohon isi tanggal/keterangan transfusi sebelumnya.' });
                    return;
                }
            }

            if (this.form_edit.reaksi_transfusi === 'Ya') {
                if (!this.form_edit.gejala_transfusi || this.form_edit.gejala_transfusi.trim() === '') {
                    this.$q.notify({ type: 'negative', message: 'Mohon jelaskan gejala reaksi transfusi.' });
                    return;
                }
            }

            if (this.form_edit.coomb_test === 'Ya') {
                if (!this.form_edit.coomb_tempat || this.form_edit.coomb_tempat.trim() === '' ||
                    !this.form_edit.coomb_kapan || this.form_edit.coomb_kapan.trim() === '' ||
                    !this.form_edit.coomb_hasil || this.form_edit.coomb_hasil.trim() === '') {
                    this.$q.notify({ type: 'negative', message: 'Mohon lengkapi data pemeriksaan serologi (Coomb\'s test): tempat, kapan, dan hasil.' });
                    return;
                }
            }

            this.btn_edit = true;
            try {
                const URL = this.$store.state.url.PERMINTAAN || (this.$store.state.url.BASE || '') + "permintaan_darah/";
                const res = await fetch(URL + "edit", {   // NOTE: endpoint backend contoh = /permintaan_darah/edit
                    method: "POST",
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.form_edit)
                });
                const json = await res.json();
                if (json && json.success) {
                    this.$q.notify({ type: 'positive', message: json.message || 'Perubahan tersimpan' });
                    this.mdl_edit = false;
                    this.getView();
                } else {
                    this.$q.notify({ type: 'negative', message: json.message || 'Gagal menyimpan perubahan' });
                }
            } catch (err) {
                console.error('Error submitEdit:', err);
                this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat menyimpan perubahan' });
            } finally {
                this.btn_edit = false;
            }
        },



        async openLihat(row) {
            this.mdl_lihat = true;
            this.lihat_target = null;

            const URL =
                (this.$store.state.url.PERMINTAAN ||
                    this.$store.state.url.BASE + 'permintaan_darah/') +
                'detail/' + row.id;

            try {
                const res = await fetch(URL, {
                    headers: {
                        authorization: 'kikensbatara ' + localStorage.token
                    }
                });
                const json = await res.json();

                if (json.success) {
                    this.lihat_target = json.data;
                } else {
                    this.$q.notify({
                        type: 'negative',
                        message: 'Gagal memuat detail permintaan'
                    });
                    this.mdl_lihat = false;
                }
            } catch (e) {
                console.error(e);
                this.$q.notify({
                    type: 'negative',
                    message: 'Error ambil detail permintaan'
                });
                this.mdl_lihat = false;
            }
        },


        updateStatusRequest(payload) {
            const URL = this.$store.state.url.PERMINTAAN || (this.$store.state.url.BASE || '') + "permintaan_darah/";
            return fetch(URL + "updateStatus", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(payload)
            })
                .then(res => res.json())
        },


        async openPeriksaFor(row) {

            this.btn_periksa = true;

            try {
                // set status = 2 (Diperiksa)
                const payload = { id: row.id, status: 2 };
                const res = await this.updateStatusRequest(payload);

                // update local UI
                row.status = 2;
                if (this.lihat_target && this.lihat_target.id === row.id) {
                    this.lihat_target.status = 2;
                    this.lihat_target.status_keterangan = 'Permintaan Sedang diperiksa';
                }

                // set periksa_target (dipakai di template)
                this.periksa_target = row;

                // isi form1 (prefill)
                this.form1 = {
                    id: row.id,
                    petugas_pemeriksa: row.petugas_pemeriksa || '',
                    komponen_id: row.komponen_id || null,
                    // set tanggal pemeriksaan sebagai TIMESTAMP (milidetik) lokal
                    tanggal_pemeriksaan: Date.now(),

                    exp: row.exp || new Date().toISOString().slice(0, 10),
                    golongan_darah: row.golongan_darah || '',
                    rhesus: row.rhesus || '',
                    kadar_hb: row.kadar_hb || null,
                    catatan_tambahan: row.catatan_tambahan || '',
                    crossmatch_1: row.crossmatch_1 || '',
                    crossmatch_2: row.crossmatch_2 || '',
                    crossmatch_3: row.crossmatch_3 || '',
                    jumlah_darah_diberikan: row.jumlah_darah_diberikan || null,
                    jumlah_darah_diberikan_cc: row.jumlah_darah_diberikan_cc || null,
                    nomor_kantong: row.nomor_kantong || ''
                };

                this.mdl_periksa = true;
                this.getView();
            } catch (err) {
                console.error('Error openPeriksaFor:', err);
                this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat memulai pemeriksaan' });
            } finally {
                this.btn_periksa = false;
            }
        },

        async saveStage1() {

            if (!this.form1.komponen_id) {
                this.$q.notify({
                    type: 'negative',
                    message: 'Komponen darah wajib diisi pada tahap pemeriksaan'
                });
                return;
            }
            // minimal validation
            if (!this.form1 || !this.form1.id) {
                this.$q.notify({ type: 'negative', message: 'Form pemeriksaan belum terisi dengan benar' });
                return;
            }
            if (!this.form1.petugas_pemeriksa) {
                this.$q.notify({ type: 'negative', message: 'Petugas pemeriksa harus diisi' });
                return;
            }

            this.loading1 = true;
            try {
                // payload untuk tahap 1 -> set status = 3 (Siap Diambil)
                const payload = {
                    id: this.form1.id,
                    status: 3,
                    status_keterangan: 'Siap diambil - Menunggu pengambilan oleh keluarga/ruangan',
                    komponen_id: this.form1.komponen_id,
                    petugas_pemeriksa: this.form1.petugas_pemeriksa,
                    golongan_darah: this.form1.golongan_darah,
                    rhesus: this.form1.rhesus,
                    rhesus: this.form1.rhesus || null,
                    exp: this.form1.exp || null,
                    catatan_tambahan: this.form1.catatan_tambahan || null,
                    crossmatch_1: this.form1.crossmatch_1 || null,
                    crossmatch_2: this.form1.crossmatch_2 || null,
                    crossmatch_3: this.form1.crossmatch_3 || null,
                    jumlah_darah_diberikan: this.form1.jumlah_darah_diberikan || null,
                    jumlah_darah_diberikan_cc: this.form1.jumlah_darah_diberikan_cc || null,
                    nomor_kantong: this.form1.nomor_kantong || null
                };

                const res = await this.updateStatusRequest(payload);
                if (!res || !res.success) {
                    this.$q.notify({ type: 'negative', message: res && res.message ? res.message : 'Gagal menyimpan hasil pemeriksaan' });
                    return;
                }

                this.$q.notify({ type: 'positive', message: res.message || 'Simpan tahap 1 berhasil. Lanjut ke Tahap 2.' });

                // update lihat_target (jika terbuka)
                if (this.lihat_target && this.lihat_target.id === this.form1.id) {
                    this.lihat_target.status = 3;
                    this.lihat_target.status_keterangan = payload.status_keterangan;
                    Object.assign(this.lihat_target, {
                        petugas_pemeriksa: payload.petugas_pemeriksa,
                        tanggal_pemeriksaan: payload.tanggal_pemeriksaan,
                        golongan_darah: payload.golongan_darah,
                        rhesus: payload.rhesus,
                        catatan_tambahan: payload.catatan_tambahan,
                        crossmatch_1: payload.crossmatch_1,
                        crossmatch_2: payload.crossmatch_2,
                        crossmatch_3: payload.crossmatch_3,
                        jumlah_darah_diberikan: payload.jumlah_darah_diberikan,
                        jumlah_darah_diberikan_cc: payload.jumlah_darah_diberikan_cc,
                        nomor_kantong: payload.nomor_kantong
                    });
                }

                this.$q.notify({ type: 'positive', message: 'Darah Siap diambil.' });
                this.mdl_periksa = false;
                this.getView();

            } catch (err) {
                console.error('saveStage1 error', err);
                this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat menyimpan tahap 1' });
            } finally {
                this.loading1 = false;
            }
        },


        // Stage 2 (simpan pengambilan) -> status = 4 (Selesai)
        async saveStage2() {
            if (!this.stage2_target || !this.stage2_target.id) {
                this.$q.notify({ type: 'negative', message: 'Tidak ada permintaan yang dipilih untuk pengambilan' });
                return;
            }

            // validasi minimal
            if (!this.form2.petugas_pengeluar || !this.form2.penerima_darah) {
                this.$q.notify({ type: 'negative', message: 'Isi semua field wajib pengambilan' });
                return;
            }

            this.loading2 = true;

            try {
                const payload = {
                    id: this.stage2_target.id,
                    status: 6, // selesai / sudah diambil
                    status_keterangan: 'Sudah diambil',
                    petugas_pengeluar: this.form2.petugas_pengeluar,
                    penerima_darah: this.form2.penerima_darah,
                    catatan_pengambilan: this.form2.catatan_pengambilan || null
                };

                const res = await this.updateStatusRequest(payload);

                if (!res || !res.success) {
                    this.$q.notify({ type: 'negative', message: res && res.message ? res.message : 'Gagal menyimpan pengambilan' });
                    return;
                }

                this.$q.notify({ type: 'positive', message: res.message || 'Pengambilan berhasil disimpan. Permintaan selesai.' });

                // update local lihat_target jika relevan
                if (this.lihat_target && this.lihat_target.id === this.stage2_target.id) {
                    this.lihat_target.status = 4;
                    this.lihat_target.status_keterangan = payload.status_keterangan;
                    Object.assign(this.lihat_target, {
                        petugas_pengeluar: payload.petugas_pengeluar,
                        penerima_darah: payload.penerima_darah,
                        catatan_pengambilan: payload.catatan_pengambilan
                    });
                }

                // tutup modal stage2 dan refresh daftar
                this.mdl_stage2 = false;
                this.stage2_target = null;
                this.getView();

            } catch (err) {
                console.error('Error saveStage2:', err);
                this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat menyimpan pengambilan' });
            } finally {
                this.loading2 = false;
            }
        },

        // tombol 'Ditolak' -> buka modal isian alasan
        openReject(row) {
            this.reject_reason = '';
            this.lihat_target = row;
            this.mdl_reject = true;
        },

        lihatKeterangan(item) {
            // salin objek agar tidak merubah referensi asli
            this.selectedItem = Object.assign({}, item || {});
            this.mdl_keterangan = true;
        },

        closeKeterangan() {
            this.mdl_keterangan = false;
            // reset selectedItem sedikit setelah dialog tertutup (untuk state bersih)
            setTimeout(() => { this.selectedItem = {}; }, 200);
        },

        // kirim penolakan -> status = 4
        submitReject() {
            if (!this.lihat_target || !this.lihat_target.id) {
                this.$q.notify({ type: 'negative', message: 'Tidak ada permintaan yang dipilih' });
                return;
            }
            if (!this.reject_reason || !String(this.reject_reason).trim()) {
                this.$q.notify({ type: 'negative', message: 'Alasan penolakan wajib diisi' });
                return;
            }
            this.btn_reject = true;
            const payload = {
                id: this.lihat_target.id,
                status: 5,
                status_keterangan: this.reject_reason
            };
            this.updateStatusRequest(payload)
                .then(res => {
                    if (res && res.success) {
                        this.$q.notify({ type: 'positive', message: res.message || 'Permintaan berhasil ditolak' });
                        this.mdl_reject = false;
                        this.lihat_target = null;
                        this.getView();
                    } else {
                        this.$q.notify({ type: 'negative', message: res.message || 'Gagal menolak permintaan' });
                    }
                })
                .catch(err => {
                    console.error('Error submitReject:', err);
                    this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat mengirim penolakan' });
                })
                .finally(() => this.btn_reject = false);
        },

        openDelete(data) {
            if (!data || !data.id) {
                console.warn("⚠️ Tidak ada data yang dipilih untuk dihapus:", data)
                return
            }

            this.form = { id: data.id }
            this.mdl_delete = true
        },

        // kirim ke backend
        removeData() {
            this.$store.commit("shoWLoading")

            fetch(this.$store.state.url.PERMINTAAN + "delete", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({ id: this.form.id })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.$store.commit("hideLoading")
                    if (res_data.success) {
                        this.Notify(res_data.message || '✅ Sukses Menghapus Data', 'negative', 'check_circle_outline')
                        this.getView()
                    } else {
                        this.Notify(res_data.message || '⚠️ Gagal menghapus data', 'warning', 'error_outline')
                    }
                })
                .catch(err => {
                    this.$store.commit("hideLoading")
                    this.Notify('❌ Terjadi kesalahan: ' + err.message, 'warning', 'error_outline')
                })
        },

        closePeriksa() {
            this.mdl_periksa = false;
            this.periksa_target = null;
            // reset form1 agar bersih
            this.form1 = {
                id: null,
                petugas_pemeriksa: '',
                tanggal_pemeriksaan: '',
                golongan_darah: '',
                rhesus: '',
                kadar_hb: null,
                catatan_tambahan: '',
                crossmatch_1: '',
                crossmatch_2: '',
                crossmatch_3: '',
                jumlah_darah_diberikan: null,
                jumlah_darah_diberikan_cc: null,
                nomor_kantong: ''
            };
            this.loading1 = false;
        },

        openStage2(row) {
            if (!row || !row.id) {
                this.$q.notify({ type: 'negative', message: 'Data permintaan tidak valid' });
                return;
            }

            const st = Number(row.status);

            if (st === 3) {
                // Buka modal Stage 2 untuk input pengambilan (seperti sebelumnya)
                this.stage2_target = { id: row.id };
                // prefill form2 bila ada data
                this.form2 = {
                    petugas_pengeluar: row.petugas_pengeluar || '',
                    penerima_darah: row.penerima_darah || '',
                    tanggal_pengambilan: row.tanggal_pengambilan || null,
                    jam_pengambilan: row.jam_pengambilan || null,
                    catatan_pengambilan: row.catatan_pengambilan || ''
                };
                this.mdl_stage2 = true;
                return;
            }

            if (st === 6) {
                // Buka modal read-only untuk data pengambilan
                this.taken_target = Object.assign({}, row);
                this.mdl_taken = true;
                return;
            }
            if (st === 4) {
                // Buka modal read-only untuk data pengambilan
                this.taken_target = Object.assign({}, row);
                this.mdl_taken_ruangan = true;
                return;
            }

            // fallback: jika bukan 3 atau 6, buka keterangan seperti biasa
            this.lihatKeterangan(row);
        },

        closeTaken() {
            this.mdl_taken = false;
            this.mdl_taken_ruangan = false;
            this.taken_target = null;
        },


        closeStage2() {
            this.mdl_stage2 = false;
            this.stage2_target = null;
            this.form2 = {
                petugas_pengeluar: '',
                penerima_darah: '',

                catatan_pengambilan: ''
            };
            this.loading2 = false;
        },

        async confirmTaken() {
            if (!this.taken_target || !this.taken_target.id) {
                this.$q.notify({ type: 'negative', message: 'Data tidak valid' });
                return;
            }

            this.loadingTaken = true;

            try {
                const payload = {
                    id: this.taken_target.id,
                    status: 4,                           // ubah status ke 4 (Diterima)
                    status_keterangan: "Darah telah diterima"
                };

                const res = await this.updateStatusRequest(payload);

                if (!res || !res.success) {
                    this.$q.notify({ type: 'negative', message: res?.message || 'Gagal mengubah status' });
                    return;
                }

                this.$q.notify({ type: 'positive', message: 'Status berhasil diubah menjadi Diterima' });

                // tutup modal dan refresh list
                this.mdl_taken = false;
                this.taken_target = null;
                this.getView();

            } catch (err) {
                console.error("Error confirmTaken:", err);
                this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat mengubah status' });
            } finally {
                this.loadingTaken = false;
            }
        },


        Notify(message, color, icon) {
            this.$q.notify({
                message,
                color,
                icon,
                position: 'top',
                timeout: 1000
            })
        },
        indexing(idx) {
            return ((this.page_first - 1) * this.page_limit) + idx
        },

        cari_data() {
            this.page_first = 1
            this.getView()
        },

        applyFilter() {
            this.page_first = 1
            this.getView()
        },

        statusText(code, keterangan) {
            // code mungkin string atau number
            const c = Number(code)
            if (c === 1) return 'Menunggu Diperiksa oleh Admin UPD'
            if (c === 2) return 'Permintaan Sedang diperiksa'
            if (c === 3) return 'Siap Diambil (Menunggu Pengambilan)'
            if (c === 4) return 'Permintaan Darah sudah Berhasil'
            if (c === 6) return 'Darah Telah di Ambil Petugas Ruangan/Keluarga Pasien'
            if (c === 5) return keterangan || 'Ditolak'
            return '-'
        },
        formatDateFromTimestamp(ts) {
            if (!ts) return '';
            const d = (typeof ts === 'number') ? new Date(ts) : new Date(Number(ts));
            const pad = n => String(n).padStart(2, '0');
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
            // atau return human readable: `${pad(d.getDate())}-${d.toLocaleString('default',{month:'short'})}-${d.getFullYear()}`
        },

    },

    watch: {
        'form.jenis_kelamin'(val) {
            if (val !== 'P') {
                // reset fields khusus wanita
                this.form.jumlah_kehamilan = null;
                this.form.pernah_abortus = '';
                this.form.pernah_hdn = '';
            }
        }
    },



    mounted() {
        // ambil profile dari localStorage (sesuai contoh kamu)
        try {
            const get_profile = JSON.parse(localStorage.profile || '{}')
            if (get_profile && get_profile.profile) {
                this.tipe = Number(get_profile.profile.stokdarah_konut)
                this.user = get_profile
                // jika admin ruangan otomatis isi rumah_sakit_id / ruangan_id jika tersedia di profile
                if (get_profile.profile.ruangan_id) {
                    this.form.ruangan_id = Number(get_profile.profile.ruangan_id)
                }
                if (get_profile.profile.rumah_sakit_id) {
                    this.form.rumah_sakit_id = Number(get_profile.profile.rumah_sakit_id)
                }
            }
        } catch (e) {
            console.warn('Gagal parse localStorage.profile', e)
        }

        this.getKomponen()
        this.getView()
        // this.getRuangan()
        this.form.rumah_sakit_id = 1;
    }
}
